import React, { Component } from 'react';
import { hasData, sliceData } from '../../data/DataStore';
import PropTypes from 'prop-types';

class CardContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {willRender: true, index: 0};
    }

    componentWillMount() {
        const { cardModel, onNullRender } = this.props;
        this.setState({ willRender: hasData(cardModel) }, () => {
            if(!this.state.willRender && this.props.onNullRender){
                onNullRender();
            }
        });
    }

    render() {
        const { cardModel, itemsToRender, component, onNullRender, ...compProps } = this.props;

        if (this.state.willRender) {
            let data, onNext, onPrevious, nextSet;
            if(Array.isArray(cardModel) && itemsToRender) {
                nextSet = this.state.index + itemsToRender;
                if(nextSet < cardModel.length)
                    onNext = () => {this.setState({index: nextSet}) };

                if(this.state.index > 0)
                    onPrevious = () => {let newIndex = this.state.index - itemsToRender; this.setState({index: newIndex})};

                data  = sliceData(cardModel, nextSet, this.state.index);

            } else {
                data = cardModel;
            }
            const Component = component;
            return (
                <Component {...compProps} cardModel={data} onNext={onNext} onPrevious={onPrevious} />);
        } else {
            return null;
        }
    }
}

CardContainer.defaultProps = {
    onNullRender: () => {}
};
CardContainer.propTypes = {
    cardModel : PropTypes.any,
    itemsToRender : PropTypes.number,
    component : PropTypes.func.isRequired,
    onNullRender : PropTypes.func
}

export default CardContainer;



// WEBPACK FOOTER //
// ./src/react/containers/CardContainer.jsx